module.exports = require("./nl-SX.d.ts");